const DRIVE = 'DRIVE';
const FLY = 'FLY';
const STAY = 'STAY';
const DEFAULT_COLLISION_AVOIDANCE = {
    side: 'none',
    align: 'none',
    fallbackAxisSide: 'none'
};
export { DEFAULT_COLLISION_AVOIDANCE, DRIVE, FLY, STAY };
